import { useEffect, useId, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { STUDIO_HASH } from '../routes'

export function CampaignStudioPrompt() {
  const [explainerOpen, setExplainerOpen] = useState(false)
  const explainerId = useId()
  const explainerTitleId = useId()
  const infoButtonRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    if (!explainerOpen) return

    function handleKeyDown(event: KeyboardEvent) {
      if (event.key !== 'Escape') return
      setExplainerOpen(false)
      window.requestAnimationFrame(() => infoButtonRef.current?.focus())
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [explainerOpen])

  function closeExplainer() {
    setExplainerOpen(false)
    window.requestAnimationFrame(() => infoButtonRef.current?.focus())
  }

  return (
    <>
      <div className="campaign-studio-prompt-wrap">
        <a
          className="campaign-studio-prompt"
          href={STUDIO_HASH}
          aria-label="Brand my Model X in the Placement Studio"
        >
          <span className="campaign-studio-prompt__signal" aria-hidden="true" />
          <span className="campaign-studio-prompt__copy">
            <span>Put your brand in motion</span>
            <strong>Brand my Model X</strong>
          </span>
          <span className="campaign-studio-prompt__arrow" aria-hidden="true">
            ↗
          </span>
        </a>

        <button
          className="campaign-studio-prompt__info"
          type="button"
          aria-controls={explainerId}
          aria-expanded={explainerOpen}
          aria-label="How Model X sponsorship works"
          ref={infoButtonRef}
          onClick={() => setExplainerOpen((current) => !current)}
        >
          <span aria-hidden="true">i</span>
        </button>
      </div>

      {explainerOpen
        ? createPortal(
            <section
              className="campaign-sponsorship-explainer"
              id={explainerId}
              role="dialog"
              aria-labelledby={explainerTitleId}
            >
              <div className="campaign-sponsorship-explainer__header">
                <div>
                  <span>Campaign guide</span>
                  <h2 id={explainerTitleId}>How sponsorship works</h2>
                </div>
                <button
                  type="button"
                  aria-label="Close sponsorship information"
                  onClick={closeExplainer}
                >
                  ×
                </button>
              </div>

              <div className="campaign-sponsorship-explainer__body">
                <p>
                  The Model X is planned to wear a deep-blue wrap. Approved
                  logos, images, icons, and messages can then be produced as
                  vehicle graphics for eligible exterior areas.
                </p>
                <p>
                  Every design is reviewed before installation. No profanity,
                  hate, harassment, illegal or deceptive content, infringement,
                  unsafe placement, or material I cannot responsibly display.
                </p>
                <p>
                  The standard planning term is 12 months—long enough for a real
                  campaign run. Exact start dates, upkeep, replacement, content,
                  downtime, and removal terms belong in our written agreement.
                </p>
                <p>
                  A Permanent campaign placement can also be discussed. Here,
                  Permanent means for the operational life of this specific
                  campaign vehicle, not forever. Sale, retirement, repainting,
                  damage, total loss, legal requirements, or campaign closure
                  may end or change it.
                </p>
                <p>
                  The goal is $1,000,000 in gross sponsorship sales. A mockup is
                  not reserved or approved until we both agree in writing.
                </p>
              </div>

              <a
                className="campaign-sponsorship-explainer__contact"
                href="mailto:iftatbhuiyan100@gmail.com?subject=Million%20Dollar%20Model%20X%20sponsorship"
              >
                Contact me to work out the details
              </a>
            </section>,
            document.body,
          )
        : null}
    </>
  )
}
